import React from 'react';
import Board from './components/Board';

function App() {
  return <Board />;
}

export default App;
